<div class="px-4 py-2 bg-white">
  <h1>Order Booking Health Check Configuration</h1>
  <p class="mb-0">
    Turn individual checks off for a customer, department or team. The most specific rule wins:
    team, then department, then customer. A check with no rule runs on every booking.
  </p>
</div>

<div
  class="border-1 border-gray-100 px-4 py-2 bg-white flex gap-2 align-items-center justify-content-between"
>
  <button pButton type="button" icon="fa fa-plus" label="Add rule" (click)="addNew()"></button>
  <order-booking-check-info></order-booking-check-info>
</div>

<div class="px-4 py-4">
  <p-table [value]="configurations" [loading]="isLoading">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 26%">Check</th>
        <th style="width: 20%">Customer</th>
        <th style="width: 18%">Department</th>
        <th style="width: 18%">Team</th>
        <th style="width: 10%" class="text-center">Enabled</th>
        <th style="width: 8%"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-configuration>
      <tr>
        <td>{{ configuration.orderBookingCheckTitle }}</td>
        <td [class.text-gray-500]="!configuration.customerName">
          {{ configuration.customerName || 'All customers' }}
        </td>
        <td [class.text-gray-500]="!configuration.customerDepartmentName">
          {{ configuration.customerDepartmentName || 'All departments' }}
        </td>
        <td [class.text-gray-500]="!configuration.customerTeamName">
          {{ configuration.customerTeamName || 'All teams' }}
        </td>
        <td class="text-center">
          <p-inputSwitch
            [ngModel]="configuration.isEnabled"
            [disabled]="togglingId === configuration.id"
            (onChange)="toggleEnabled(configuration, $event.checked)"
          ></p-inputSwitch>
        </td>
        <td class="text-right">
          <button
            pButton
            type="button"
            icon="fa fa-pencil"
            title="Change what this rule applies to"
            class="ui-button-secondary mr-1"
            (click)="edit(configuration)"
          ></button>
          <button
            pButton
            type="button"
            icon="fa fa-trash"
            title="Remove this rule"
            class="ui-button-danger"
            (click)="remove(configuration)"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">No rules yet, so every check runs on every booking.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  [header]="editing?.id ? 'Edit rule' : 'Add rule'"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '520px' }"
>
  <div class="p-fluid" *ngIf="editing">
    <div class="field">
      <label for="rule-check">Check</label>
      <p-dropdown
        inputId="rule-check"
        [options]="checkTypes"
        [(ngModel)]="editing.orderBookingCheckId"
        placeholder="Choose a check"
        appendTo="body"
      ></p-dropdown>
    </div>
    <div class="field">
      <label for="rule-customer">Customer</label>
      <p-dropdown
        inputId="rule-customer"
        [options]="customerOptions"
        [(ngModel)]="editing.customerId"
        [filter]="true"
        appendTo="body"
        (onChange)="onCustomerChanged()"
      ></p-dropdown>
    </div>
    <div class="field">
      <label for="rule-department">Department</label>
      <p-dropdown
        inputId="rule-department"
        [options]="departmentOptions"
        [(ngModel)]="editing.customerDepartmentId"
        [disabled]="!editing.customerId"
        appendTo="body"
        (onChange)="onDepartmentChanged()"
      ></p-dropdown>
    </div>
    <div class="field">
      <label for="rule-team">Team</label>
      <p-dropdown
        inputId="rule-team"
        [options]="teamOptions"
        [(ngModel)]="editing.customerTeamId"
        [disabled]="!editing.customerDepartmentId"
        appendTo="body"
      ></p-dropdown>
    </div>
    <div class="field flex align-items-center gap-2">
      <p-inputSwitch [(ngModel)]="editing.isEnabled"></p-inputSwitch>
      <label class="mb-0">Check is enabled</label>
    </div>
  </div>
  <p-footer>
    <button
      pButton
      type="button"
      label="Cancel"
      class="ui-button-secondary"
      (click)="showDialog = false"
    ></button>
    <button pButton type="button" label="Save" [disabled]="saving" (click)="save()"></button>
  </p-footer>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
